import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { AppRoutes } from "../../routes/routes";
import { Breadcrumb } from "../breadcrumb";
import { UserTabs } from "../user-tabs";
import { AuditLogListView } from "./audit-log-list-view";
export const AuditLogView = observer(() => {
    return (_jsxs("div", { children: [_jsx(Breadcrumb, {}), _jsxs("div", { className: "card mb-5", children: [_jsx("div", { className: "card-header", children: _jsx(UserTabs, { selected: AppRoutes.AuditLog }) }), _jsx(AuditLogListView, {})] })] }));
});
export const renderAuditLogType = (logType) => {
    switch (logType) {
        case "activation":
            return _jsx("span", { className: "badge text-bg-primary", children: logType });
        case "operation":
            return _jsx("span", { className: "badge text-bg-secondary", children: logType });
        case "signature":
            return _jsx("span", { className: "badge text-bg-success", children: logType });
        default:
            return _jsx("span", { className: "badge text-bg-dark", children: logType });
    }
};
